export default __webpack_public_path__ + "static/media/GMaduroPresidenteClosed.b4e37ef6.jpg";